import * as moment from 'moment';
import * as _ from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Card } from '../../models/card.model';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { ConfigurationService } from '../../services';
import { createNumberMask } from 'text-mask-addons/dist/textMaskAddons';
import { Direction } from '../../models/direction';
import {
  CurrencySymbolPipe,
  FirstCC,
  SecondCC,
  ShortNumberPipe,
} from '../../helpers/pipes';
import { HttpClient } from '@angular/common/http';
import { Price } from '../../models/price';
import { StateService } from '../../services/state.service';
import { Trade } from '../../models/trade';
import { TradeModalComponent } from '../trade-modal/trade-modal.component';
import { DataexchangeService } from '../../services/dataexchange.service';
import { Subscription } from 'rxjs';
import { UserService } from '../../services/user.service';
import 'moment-timezone';
import { DateService } from '../../services/date.service';
import { TabView } from '../../models/tab.view';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { TabsetConfig } from 'ngx-bootstrap/tabs';
import { Store } from '@ngrx/store';
import { MatchBoardState } from '../../store/state/reducers/matchboard.reducers';
import {
  getCurrencyMappingsSelector,
  getCurrencyPairsSelector,
  getGraphDataSelector,
  getLastTradePricesSelector,
  getSelectedOnBehalfUserSelector,
  getSpotPricesSelector,
  getTopOrdersSelector,
} from '../../store/state/selectors/matchboard.selectors';
import { CurrencyDto } from '../../models/CurrencyDto';
import { PriceService } from '../../services/price.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { DragDisableHandler } from '../../services/DragDisableHandler';
import { SocketService } from '../../services/SocketService';

@Component({
  selector: 'app-price-panel',
  templateUrl: './price-panel.component.html',
  styleUrls: ['./price-panel.component.scss'],
  providers: [
    FirstCC,
    SecondCC,
    ShortNumberPipe,
    CurrencySymbolPipe,
    {
      provide: TabsetConfig,
      useValue: {
        isKeysAllowed: false,
        type: 'tabs',
      },
    },
  ],
  encapsulation: ViewEncapsulation.None,
})
export class PricePanelComponent
  extends DragDisableHandler
  implements OnInit, OnDestroy, AfterViewInit
{
  subscriptions: Array<Subscription>;

  isSuperUser: boolean;
  selectedOnBehalfUser: any;

  modalRef: BsModalRef;

  tabs: TabView[] = [];
  activeTab: number;
  editTabNameForm: FormGroup;
  newTabModalForm: FormGroup;

  card: any;

  name: any;
  id: any;

  public mask = [];
  numberValue = '';

  Math: any;

  graphData = {};

  lastTradesByCps: any;

  Tenors = [];

  spotPrices: any;

  @ViewChild('newTabModal')
  newTabModalTemplate: TemplateRef<any>;

  newTabModalRef: BsModalRef;

  isOpen: boolean;

  newTabName: string;

  currencyPairs: CurrencyDto[];
  currencyPairsJson: { [k: number]: CurrencyDto };

  topOrders: { [k: string]: { [d: string]: Array<Price> } };

  currencyMappings: any;

  drop(event: CdkDragDrop<Card>, tabindex) {
    moveItemInArray(
      this.tabs[tabindex].cards,
      event.previousIndex,
      event.currentIndex,
    );
    if (!this.isSuperUser) {
      this.refreshCardOrder(this.tabs[tabindex].cards);
    }
  }

  refreshCardOrder(cards) {
    cards.map((value, index) => {
      value.index = index;
      return value;
    });
  }

  constructor(
    private readonly modalService: BsModalService,
    private httpService: HttpClient,
    private stateService: StateService,
    private configurationService: ConfigurationService,
    private renderer: Renderer2,
    private dataexchangeService: DataexchangeService,
    private userService: UserService,
    private dateService: DateService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private readonly translate: TranslateService,
    private readonly store: Store<MatchBoardState>,
    private readonly priceService: PriceService,
    private socketService: SocketService,
  ) {
    super();
    this.Math = Math;
    this.mask = createNumberMask({
      prefix: '',
      suffix: '',
      allowDecimal: true,
      decimalLimit: 2,
      decimalSymbol: '.',
      includeThousandsSeparator: true,
      allowLeadingZeroes: true,
      integerLimit: 13,
    });
    this.subscriptions = new Array<Subscription>();
  }

  ngAfterViewInit(): void {
    if (!this.isSuperUser) {
      document
        .getElementsByClassName('addBoxTab')[0]
        .addEventListener('click', () => {
          this.addBoxTab();
        });
    }
  }

  addBoxTab() {
    const formArray = this.editTabNameForm.controls['tabs'] as FormArray;
    this.clickOutsideSubmit();
    if (this.activeTab === 0 || formArray.controls[this.activeTab - 1].valid) {
      this.addNewTab();
    }
  }

  addNewTab(): void {
    this.isOpen = false;
    this.newTabModalRef = this.modalService.show(this.newTabModalTemplate, {
      animated: false,
      ignoreBackdropClick: true,
      backdrop: false,
      class: 'modal-shadow modal-sm',
    });
    this.subscriptions.push(
      this.modalService.onHide.subscribe(() => {
        this.newTabModalForm.reset({ newTabName: '' });
      }),
    );
  }

  clickOutsideSubmit() {
    const formArray: FormArray = this.editTabNameForm.controls[
      'tabs'
    ] as FormArray;
    const actualTabForm = formArray.at(this.activeTab - 1) as FormGroup;
    const activeTab = this.tabs[this.activeTab];

    try {
      if (
        this.activeTab !== 0 &&
        actualTabForm.value.tabName !== activeTab.name
      ) {
        this.submitTabName();
      }
    } catch (e) {
      console.log(e);
    }
  }

  submitTabName() {
    const formArray: FormArray = this.editTabNameForm.controls[
      'tabs'
    ] as FormArray;
    const actualTabForm = formArray.at(this.activeTab - 1) as FormGroup;

    if (actualTabForm && actualTabForm.invalid) {
      if (actualTabForm.controls['tabName'].errors['required']) {
        this.toastr.error(this.translate.instant('addTitleErrorMessage'));
      }
      if (actualTabForm.controls['tabName'].errors['validateNewTabName']) {
        this.toastr.error(
          this.translate.instant('addUniqueTabNameErrorMessage'),
        );
      }
      actualTabForm.reset({ tabName: this.tabs[this.activeTab].name });
      this.tabs[this.activeTab].isAnimationActive = 'closed';
      return;
    }
    const oldTabName = this.tabs[this.activeTab].name;
    this.tabs[this.activeTab].name = actualTabForm.getRawValue().tabName;
    actualTabForm.reset({ tabName: this.tabs[this.activeTab].name });

    this.socketService.send('renameTab', {
      tabName: oldTabName,
      newTabName: this.tabs[this.activeTab].name,
    });
  }

  validateEditedTabName(c: FormControl) {
    let numberOfSameTabNames = 0;
    const formArray: FormArray = this.editTabNameForm.controls[
      'tabs'
    ] as FormArray;
    const activeTab = this.tabs[this.activeTab];

    for (let i = 0; i < formArray.length; i++) {
      if (
        formArray.controls[i].value.tabName === c.value &&
        c.value !== activeTab.name
      ) {
        numberOfSameTabNames++;
      }
    }

    if (numberOfSameTabNames > 0) {
      return {
        validateNewTabName: {
          valid: false,
        },
      };
    }
    return undefined;
  }

  finalizeNewTab(cards: Card[]) {
    const formArray: FormArray = this.editTabNameForm.controls[
      'tabs'
    ] as FormArray;
    if (this.activeTab !== 0) {
      formArray.at(this.activeTab - 1).disable();
    }

    const newTab = new TabView(
      _.clone(this.newTabName),
      cards,
      true,
      'tabStyle',
    );
    this.tabs.push(newTab);
    this.tabs[this.activeTab].active = false;
    this.activeTab = this.tabs.indexOf(newTab);

    newTab.active = true;
    formArray.push(
      this.fb.group({
        tabName: new FormControl(this.newTabName, [
          Validators.required,
          this.validateEditedTabName.bind(this),
        ]),
      }),
    );

    this.newTabName = null;
  }

  submitNewTab() {
    if (this.newTabModalForm.invalid) {
      this.isOpen = true;
      return;
    }
    this.isOpen = false;
    this.newTabModalRef.hide();
    this.newTabModalRef = null;

    this.newTabName = this.newTabModalForm.value.newTabName;
    this.newTabModalForm.reset();
  }

  getGraphDataForCp(cp: string): any {
    if (this.graphData && this.graphData[cp]) {
      return this.graphData[cp];
    }
    return [];
  }

  openTradeModal(item: Card, index: number, direction: string, from: string) {
    if (!this.getCurrentMarket(item.sixLetterCode)) {
      return;
    }
    // preven scroll when the modal open
    this.renderer.addClass(document.body, 'modal-open');
    let priceBorrow: Price[];
    let priceLend: Price[];

    priceBorrow = this.getPricesForCurrencyPair(item, Direction.BORROW);
    priceLend = this.getPricesForCurrencyPair(item, Direction.LEND);

    let quantity: number = item.amount;
    if (
      from === 'borrowSideAmount' ||
      from === 'lendSideAmount' ||
      from === 'lendSideQuantity' ||
      from === 'borrowSideQuantity'
    ) {
      priceBorrow = this.getPricesForCurrencyPair(item, Direction.BORROW);
      priceLend = this.getPricesForCurrencyPair(item, Direction.LEND);
      quantity =
        direction === 'LEND'
          ? this.getPricesForCurrencyPair(item, 'BORROW')[0].quantity
          : this.getPricesForCurrencyPair(item, 'LEND')[0].quantity;
    }

    const spot = this.priceService.getSpotPriceForCurrencyPair(
      this.spotPrices,
      this.currencyMappings,
      item.sixLetterCode,
    );

    const initialState = {
      trade: new Trade(
        null,
        item.sixLetterCode,
        quantity,
        priceBorrow && priceBorrow[0] ? priceBorrow[0].price : 0,
        priceLend && priceLend[0] ? priceLend[0].price : 0,
        spot,
        quantity * spot,
        from,
        direction,
      ),
      selectedTenorId: item.swap,
    };

    this.modalRef = this.modalService.show(TradeModalComponent, {
      ignoreBackdropClick: true,
      animated: true,
      backdrop: true,
      keyboard: true, // enable Esc
      class: 'modal-lg modal-trade',
      initialState,
    });

    this.modalRef.content.tradeTypeChange.subscribe((tradeType) => {
      this.swapTypeChanged(tradeType, item, index);
    });
    this.modalRef.content.closeBtnName = 'Close';
  }

  formatCP = (num: any, ts: number, fraction = -1) => {
    if (num === undefined) {
      console.log('num error');
      return 0;
    }

    let fract;
    let first_part;
    if (fraction !== -1) {
      num = num.toFixed(fraction) + '';
    }
    if (num.toString().indexOf('.') === -1) {
      num = num + '.0';
    }
    const num_st = ts.toString();
    /* if tick size below 0 */

    if (ts < 1) {
      const f_num = num_st.length - 2;
      /* if no fraction part*/
      if (num.toString().indexOf('.') === -1) {
        fract = '';
        first_part = num.toString();
      } else {
        const start = num.toString().indexOf('.') + (f_num - 1);
        const length = 2;
        fract = num.toString().substr(start, length);
        if (start > 1) {
          first_part = num.toString().substr(0, start);
        } else if (start === 1) {
          first_part = num.toString().substr(0, 1);
        } else {
          first_part = '';
        }
      }
      fract += fract.length === 0 ? '00' : fract.length === 1 ? '0' : '';
    } else {
      if (num.toString().indexOf('.') === -1) {
        let start = num.toString().length - (num_st.length + 1);
        let length = 2;
        if (start === -1) {
          start = 0;
          length = 1;
        }
        fract = num.toString().substr(start, length);
      }
    }
    return [first_part, fract];
  };

  validateFloatKeyPress(evt, card) {
    evt = evt ? evt : window.event;
    const charCode = evt.which ? evt.which : evt.key;

    this.numberValue = evt.target.value;
    // this.numberValue = parseInt(this.numberValue, 10);

    // Prevent to write zero in lead
    if (this.numberValue[0] === '0') {
      evt.target.value = this.numberValue.replace(/^([1-9][0-9]*)|([0]+)$/, '');
    }

    // . character
    if (charCode === 190) {
      evt.target.value = this.numberValue.replace('_', '');
    }

    // M character
    if (charCode === 77) {
      let countM = this.numberValue.replace(/,/g, '');
      countM = (parseFloat(countM) * 1000000).toString();
      evt.target.value = countM;
    }

    // K character
    if (charCode === 75) {
      let countK = this.numberValue.replace(/,/g, '');
      countK = (parseFloat(countK) * 1000).toString();
      evt.target.value = countK;
    }
  }

  validateNewTabName(c: FormControl): any {
    const existingTab = this.tabs.find((item) => item.name === c.value);
    if (existingTab) {
      return {
        validateNewTabName: {
          valid: false,
        },
      };
    }
  }

  ngOnInit() {
    this.activeTab = 0;
    this.editTabNameForm = this.fb.group({
      tabs: this.fb.array([]),
    });

    this.store.select(getTopOrdersSelector).subscribe((topOrders) => {
      this.topOrders = topOrders;
    });

    this.store.select(getCurrencyPairsSelector).subscribe((currencyPairs) => {
      this.currencyPairs = currencyPairs;
      this.currencyPairsJson = {};
      this.currencyPairs.forEach(
        (cp) => (this.currencyPairsJson[cp.sixLetterCode] = cp),
      );
    });

    this.store
      .select(getCurrencyMappingsSelector)
      .subscribe((currencyMappings) => {
        this.currencyMappings = currencyMappings;
      });

    this.store.select(getSpotPricesSelector).subscribe((spotPrices) => {
      this.spotPrices = spotPrices;
    });

    this.newTabModalForm = this.fb.group({
      newTabName: new FormControl('', [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(20),
        this.validateNewTabName.bind(this),
      ]),
    });

    this.isSuperUser = this.userService.isSuperUser();

    this.store.select(getGraphDataSelector).subscribe((graphData) => {
      this.graphData = graphData;
    });

    this.store
      .select(getLastTradePricesSelector)
      .subscribe((lastTradePrices) => {
        this.lastTradesByCps = lastTradePrices;
      });

    this.store.select(getSelectedOnBehalfUserSelector).subscribe((user) => {
      if (user && !this.selectedOnBehalfUser) {
        setTimeout(() => {
          document
            .getElementsByClassName('addBoxTab')[0]
            .addEventListener('click', () => {
              this.addBoxTab();
            });
        }, 1100);
      }
      if (user) {
        this.selectedOnBehalfUser = user;
      }
    });

    this.dataexchangeService.tabs.subscribe((tabs) => {
      if (!tabs) {
        return;
      }

      this.activeTab = 0;

      this.tabs = _.cloneDeep(tabs).map(
        (t, i) =>
          new TabView(
            t.name,
            t.cards,
            i !== 0,
            i === 0 ? 'firstTab tabStyle' : 'tabStyle',
            this.activeTab === i,
          ),
      );

      this.editTabNameForm = this.fb.group({
        tabs: this.fb.array([]),
      });

      this.tabs.forEach((t, index) => {
        if (t.removable) {
          const formArray = this.editTabNameForm.controls['tabs'] as FormArray;
          formArray.push(
            this.fb.group({
              tabName: new FormControl({ value: t.name, disabled: !t.active }, [
                Validators.required,
                this.validateEditedTabName.bind(this),
              ]),
            }),
          );
        }
      });
    });

    this.Tenors = [
      { id: 1, name: 'O/N', value: 'ON' },
      { id: 2, name: 'Ti', value: 'TI' },
      { id: 3, name: 'TOD-TOM', value: 'TOD_TOM' },
      { id: 4, name: '1w', value: 'W1' },
      { id: 5, name: '2w', value: 'W2' },
    ];
  }

  getPricesForCurrencyPair(card, direction): Array<Price> {
    const pricesForCurrencyPair = this.topOrders[card.sixLetterCode];
    if (!pricesForCurrencyPair) {
      return null;
    }

    const priceForCp = pricesForCurrencyPair[direction];
    if (priceForCp) {
      const prices = priceForCp.filter((p) => p.swap === card.swap);
      return prices.length > 0 ? prices : null;
    }

    return priceForCp;
  }

  getRemainingOrders(card: Card, direction): Array<Price> {
    const pricesForCurrencyPair = this.topOrders[card.sixLetterCode];
    if (!pricesForCurrencyPair) {
      return null;
    }

    return pricesForCurrencyPair[direction]
      .filter((p) => p.swap === card.swap)
      .slice(1, 5);
  }

  getCurrentMarket(sixLetterCode: string) {
    return this.priceService.getSpotPriceForCurrencyPair(
      this.spotPrices,
      this.currencyMappings,
      sixLetterCode,
    );
  }

  getFormattedSpotPrice(card: Card, decimal: boolean) {
    const precision =
      this.configurationService.getSpotDecimalPrecisionForCurrencyPair(
        card.sixLetterCode,
      );
    if (decimal && precision === 0) {
      return null;
    }
    const curr = this.currencyPairs.find(
      (cp) => cp.sixLetterCode === card.sixLetterCode,
    );

    const formattedSpotPrice = (
      this.priceService.getSpotPriceForCurrencyPair(
        this.spotPrices,
        this.currencyMappings,
        card.sixLetterCode,
      ) * curr.spotPriceFactor
    ).toFixed(curr.displaySpotPricePrecision);

    if (!decimal) {
      return Math.floor(Number(formattedSpotPrice));
    }
    return formattedSpotPrice.split('.')[1];
  }

  getLastTradeForCp(cp: string) {
    if (this.lastTradesByCps && this.lastTradesByCps[cp] !== undefined) {
      return this.lastTradesByCps[cp];
    }
    return '';
  }

  getAbsOfLatestTradeForCP(cp: string) {
    if (this.lastTradesByCps && this.lastTradesByCps[cp] !== undefined) {
      return this.lastTradesByCps[cp];
    }
  }

  swapTypeChanged(tradeType, card, index) {
    card.swap = tradeType;
    const msg: any = {
      cardId: card.id,
      tradeType,
    };
    if (this.userService.isSuperUser()) {
      msg.controlledUserId = this.selectedOnBehalfUser;
    }
  }

  getDaysDividerToSwapRateByTradeType(swapType) {
    if (swapType === 'ON') {
      if (this.getDayDifferenceBtwFarLegDateAndNearLegDate(swapType) === 1) {
        return `<span class="nonSpecialTradeText">365</span>`;
      } else {
        const days = Math.ceil(
          365 / this.getDayDifferenceBtwFarLegDateAndNearLegDate(swapType),
        );
        return `<span class="specialONTradeText">${days}</span>`;
      }
    }
    if (swapType === 'TOD_TOM') {
      return `<span class="nonSpecialTradeText">365</span>`;
    }
    if (swapType === 'W1') {
      return `<span class="nonSpecialTradeText">52</span>`;
    }

    return `<span class="nonSpecialTradeText">26</span>`;
  }

  getDaysDividerToSwapRateByTradeTypeForCalculation(swapType): number {
    if (
      (swapType === 'ON' || swapType === 'TI') &&
      this.getDayDifferenceBtwFarLegDateAndNearLegDate(swapType) > 1
    ) {
      return 365 / this.getDayDifferenceBtwFarLegDateAndNearLegDate(swapType);
    }

    if (swapType === 'ON' || swapType === 'TI') {
      return 365;
    }

    if (swapType === 'TOD_TOM') {
      return 365;
    }
    if (swapType === 'W1') {
      return 52;
    }

    return 26;
  }

  getDayDifferenceBtwFarLegDateAndNearLegDate(tradeType): number {
    const nearLegDate = this.dateService.getNearLegDate(tradeType);
    const copy = moment(nearLegDate);
    const farLegDate = this.dateService.getTradeValueDate(copy, tradeType);
    const duration = moment.duration(farLegDate.diff(nearLegDate));
    return duration.asDays();
  }

  getTooltipDays(tradeType): string {
    const days = this.getDayDifferenceBtwFarLegDateAndNearLegDate(tradeType);
    if (tradeType === 'ON' && days > 1) {
      return `<span class="specialONTradeText">${days} days</span>`;
    }
    if (days > 1) {
      return `<span class="nonSpecialTradeText">${days} days</span>`;
    }
    return `<span class="nonSpecialTradeText">day</span>`;
  }

  changeCurrencyPair(sixLetterCode, index, card) {
    const msg: any = {
      sixLetterCode,
      cardId: card.id,
    };
    if (this.userService.isSuperUser()) {
      msg.controlledUserId = this.selectedOnBehalfUser;
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  deselectTab(tabz: TabView) {
    tabz.active = false;
  }

  selectTab(tabz: TabView) {
    if (!this.tabs) {
      return;
    }

    const formArray: FormArray = this.editTabNameForm.controls[
      'tabs'
    ] as FormArray;

    if (this.activeTab !== 0) {
      formArray.controls[this.activeTab - 1].disable();
    }

    tabz.active = true;
    this.activeTab = this.tabs.indexOf(tabz);

    if (this.activeTab !== 0) {
      formArray.controls[this.activeTab - 1].enable();
    }
  }

  removeTabHandler(tabz: TabView): void {
    const formArray: FormArray = this.editTabNameForm.controls[
      'tabs'
    ] as FormArray;
    if (this.tabs.indexOf(tabz) <= this.activeTab) {
      this.activeTab--;
      if (formArray.controls[this.activeTab].invalid) {
        this.selectTab(this.tabs[this.activeTab]);
      }
    }
    const toDeleteTabIndex = this.tabs.indexOf(tabz);

    formArray.removeAt(toDeleteTabIndex - 1);

    this.tabs.splice(toDeleteTabIndex, 1);
  }

  cancelNewTabModal() {
    this.newTabModalRef.hide();
    this.newTabModalRef = null;
    this.newTabModalForm.reset();
  }

  filter(ngSelect: NgSelectComponent, term) {
    ngSelect.filter(term);
  }
  selectEvent(event: any) {
    event.target.select();
  }

  searchInstrument(searched: string, item: any) {
    const term = searched.toLowerCase().replace('/', '');
    return (
      item.instrument.name.toLowerCase().replace('/', '').indexOf(term) > -1
    );
  }
}
